/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { SysqueTabModel } from 'libs/sysque/shared/ui/src/lib/models/sysque-tab-model';
import { CableTrayComponent } from './cable-tray/cable-tray.component';
import { ConduitSettingsComponent } from './conduit-settings';
import { IAnnotationSettingsInterface } from "../../../../../../../data-access/src/lib/domain/facades-models/annotation-settings-interface";
import { IAnnotationSettingsFacade, ANNOTATION_SETTINGS_FACADE_TOKEN } from "../../../../../../../data-access/src/lib/domain/facades-models/annotation-settings-facade-interface";
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { AnnotationSettingsTabType, CurrentSelectionResult } from '../../../../models/annotation-settings';

@Component({
  selector: 'sysque-annotation-settings-tab',
  templateUrl: './annotation-settings-tab.component.html',
  styleUrls: ['./annotation-settings-tab.component.scss'],
  standalone: false
})
export class AnnotationSettingsTabComponent implements OnInit, OnDestroy,  IAnnotationSettingsInterface {
  @Input() dataLoaded: Observable<void>;  // Receive event from parent
  @Output() validationResult = new EventEmitter<CurrentSelectionResult>();
  selectedTab: AnnotationSettingsTabType = AnnotationSettingsTabType.CableTray;
  content: SysqueTabModel[] = [];
  validSelectionSubscription: Subscription;
  validSelection$: Observable<CurrentSelectionResult>
  destroy$ = new Subject<void>();

  constructor(@Inject(ANNOTATION_SETTINGS_FACADE_TOKEN) private annotationSettingsFacade: IAnnotationSettingsFacade) { }
  
  ngOnInit(): void {
    this.titleClick = this.titleClick.bind(this);
    // Wait for loadData() to complete before initializing tabs
    this.dataLoaded.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.loadData();
    });
  }

  loadData() {
    this.content = [
      {
        component: CableTrayComponent,
        name: 'Cable Tray',
        inputs: null
      },
      {
        component: ConduitSettingsComponent,
        name: 'Conduit Settings',
        inputs: null
      },
    ]
  }

  titleClick(e: any) {
    let validRevitSelection = new CurrentSelectionResult();
    this.selectedTab = e.itemIndex === 0 ? AnnotationSettingsTabType.CableTray : AnnotationSettingsTabType.Conduit;
    this.validSelection$ = this.annotationSettingsFacade.getCurrentSelectionResult();
    this.validSelectionSubscription  = this.validSelection$.subscribe((data) => {
      validRevitSelection = data;
      this.validationResult.emit(validRevitSelection);
    });
  }

  reload(): void {
    this.ngOnInit();
  }

  ngOnDestroy(): void {
    if(this.validSelectionSubscription){
    this.validSelectionSubscription.unsubscribe();
    }
  }

}
